<template>
  <div>
    <!-- Mobile -->
    <div :class="[props.type, { 'has-bg-image': props.hasBgImage }]">
      <div class="icon-swiper-mobile">
        <div
          v-if="item.slide.length"
          class="hide-for-large"
          :class="
            props.type === 'lime-bg' || props.type === 'grey-bg'
              ? 'p-top-7 p-bot-8'
              : 'p-top-6 p-bot-6'
          "
        >
          <WidgetSliderSwiper
            :length="item.slide.length"
            :title="item.sectionTitle"
            :text="item.text"
          >
            <template
              v-for="(slide, index) in item.slide"
              :key="index"
              #[`slide-${index}`]
            >
              <IconSectionIconSlide
                :item="slide"
                :type="
                  props.type === 'lime-bg'
                    ? 'colored-slide'
                    : props.type === 'grey-bg'
                      ? 'grey-slide'
                      : ''
                "
              />
            </template>
          </WidgetSliderSwiper>
          <div
            v-if="
              item.mostraBottoneCarosello && item.mostraBottoneCarosello.length
            "
            class="m-top-8 flex --justify-center"
          >
            <nuxt-link
              class="round-icon-btn"
              :to="localePath(item.mostraBottoneCarosello[0].linkDefault)"
            >
              <span
                class="text-medium5 is-medium-bold"
                v-html="item.mostraBottoneCarosello[0].label"
              />
            </nuxt-link>
          </div>
          <div
            v-if="
              item.mostraListaLinkCarosello &&
              item.mostraListaLinkCarosello.length
            "
            class="icon-swiper-mobile__links m-top-8 row-1"
          >
            <div
              v-for="(link, index) in item.mostraListaLinkCarosello[0]
                .listaLink"
              :key="index"
            >
              <div v-if="link.linkDefault">
                <NuxtLink :to="localePath(link.linkDefault)">
                  <div
                    class="text-medium5 default-icon-btn is-dark-green is-medium-bold"
                  >
                    <span v-html="link.label" />
                    <ArrowIcon alt="Arrow icon" class="icon-arrow" />
                  </div>
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop -->
    <div :class="[props.type, { 'has-bg-image': props.hasBgImage }]">
      <div
        v-if="item.slide.length"
        class="icon-section-container row-1 show-for-large"
        :class="
          props.type === 'lime-bg' || props.type === 'grey-bg'
            ? 'p-top-7 p-bot-7'
            : 'p-top-6 p-bot-6'
        "
      >
        <div
          v-if="item.sectionTitle || item.text"
          class="icon-section-container__intro"
        >
          <div
            v-if="item.sectionTitle"
            class="title-big3 is-medium-bold title"
            v-html="item.sectionTitle"
          />
          <div
            v-if="item.text"
            class="title-base m-top-9 text"
            v-html="item.text"
          />
        </div>

        <div class="icon-section-wrap">
          <div
            v-for="(block, index) in item.slide"
            :key="index"
            class="content-block icon-section"
          >
            <div v-if="block.portrait.length" class="content-block__image">
              <WidgetPicture
                :image="{
                  portrait: block.portrait?.[0],
                }"
                :alt="block.portrait?.[0]?.title"
              />
            </div>
            <div class="content-block__text">
              <div
                v-if="block?.sectionTitle"
                class="content-block__title title-medium3 is-medium-bold"
                :style="{ color: block.coloreTitolo }"
              >
                <div v-html="block.sectionTitle" />
              </div>
              <div
                v-if="block?.text"
                class="content-block__description text-medium5"
              >
                <div v-html="block.text" />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            item.mostraListaLinkCarosello &&
            item.mostraListaLinkCarosello.length
          "
          class="icon-section__links m-top-5"
        >
          <div
            v-for="(link, index) in item.mostraListaLinkCarosello[0].listaLink"
            :key="index"
          >
            <div v-if="link.linkDefault">
              <NuxtLink :to="localePath(link.linkDefault)">
                <div
                  class="text-medium5 default-icon-btn is-dark-green is-medium-bold"
                >
                  <span v-if="link.label" v-html="link.label" />
                  <ArrowIcon alt="Arrow icon" class="icon-arrow" />
                </div>
              </NuxtLink>
            </div>
          </div>
        </div>
        <div
          v-if="
            item.mostraBottoneCarosello && item.mostraBottoneCarosello.length
          "
          class="m-top-8 flex --justify-center"
        >
          <nuxt-link
            class="round-icon-btn"
            :to="localePath(item.mostraBottoneCarosello[0].linkDefault)"
          >
            <span
              class="text-medium5 is-medium-bold"
              v-html="item.mostraBottoneCarosello[0].label"
            />
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: '',
  },
  hasBgImage: {
    type: Boolean,
    default: false,
  },
})
</script>

<script>
export default {
  name: 'IconSection',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
